import { useContext } from 'react';
import { AppDataContext } from '@acilearning/ibl-web-react-common';
import { deleteUserGroup } from './utils/licensing';

const useDeleteUserGroup = () => {
  const { setNotification } = useContext(AppDataContext);

  const deleteUserGroupById = (groupId, successCallback, errorCallback) => {
    deleteUserGroup(
      groupId,
      () => {
        setNotification({
          msg: 'User group deleted successfully.',
          success: true,
        });
        successCallback?.();
      },
      (error) => {
        setNotification({
          msg: 'Failed to delete user group.',
          success: false,
        });
        errorCallback?.(error);
      }
    );
  };

  return { deleteUserGroupById };
};

export default useDeleteUserGroup;
